// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3ErcT","title":"ClientCherryInfo_title__2q_yG","itemText":"ClientCherryInfo_itemText__3HqFS"};